/*
  Product gallery (phones): round dots under the photos instead of the "1 / 5" counter.
  It hooks into the theme's own slider (<slider-component>) without changing it:
  it reads the visible slides, follows the "slideChanged" event and scrolls the slider when a dot is tapped.
*/
if (!customElements.get('joyvo-gallery-dots')) {
  customElements.define(
    'joyvo-gallery-dots',
    class JoyvoGalleryDots extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = (this.closest('media-gallery') || document).querySelector('slider-component');
        if (!this.sliderComponent) return;
        this.list = this.sliderComponent.querySelector('.slider');
        this.build();
        this.sliderComponent.addEventListener('slideChanged', (event) => this.setActive(event.detail.currentPage - 1));
        // a new variant re-orders and hides photos: rebuild the dots when the list changes
        new MutationObserver(() => this.build()).observe(this.list, { childList: true, attributes: true, attributeFilter: ['class', 'hidden'], subtree: true });
        window.addEventListener('resize', () => this.build());
      }

      slides() {
        return [...this.list.querySelectorAll('.slider__slide')].filter((slide) => slide.offsetWidth > 0);
      }

      build() {
        const slides = this.slides();
        const signature = slides.map((slide) => slide.dataset.mediaId).join('|');
        if (signature === this.signature) return;
        this.signature = signature;
        this.innerHTML = '';
        if (slides.length < 2) return;
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'joyvo-dot';
          dot.setAttribute('aria-label', `Image ${index + 1} of ${slides.length}`);
          dot.addEventListener('click', () => this.sliderComponent.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }));
          this.appendChild(dot);
        });
        this.setActive((this.sliderComponent.currentPage || 1) - 1);
      }

      setActive(index) {
        [...this.children].forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.toggleAttribute('aria-current', i === index);
        });
      }
    }
  );
}
